import { TooltipIcon } from '@ipfabric/ui-components/Tooltip/TooltipIcon';
import { DeviceAttributesFilter } from 'components/DeviceAttributesFilter/DeviceAttributesFilter';
import type { FacetedFilterValue } from 'components/FacetedFilter/FacetedFilter';
import { Toggle } from 'components/Toggle/Toggle';
import { useState } from 'react';
import type { FC } from 'react';

const ToggleLabel = () => (
  <>
    Attributes{' '}
    <TooltipIcon
      content='Prop globalAttributes selects between all attributes or filtered by current snapshot'
      iconProps={{
        iconStyle: 'solid',
        inline: true,
      }}
      size='sm'
      className='ml-2'
    />
  </>
);

export const DeviceAttributesFilterGallerySection: FC = () => {
  const [value, setValue] = useState<FacetedFilterValue>({});
  const [globalAttributes, setGlobalAttributes] = useState<boolean>(false);

  return (
    <>
      <Toggle
        className='mb-6'
        onChange={setGlobalAttributes}
        value={globalAttributes}
        label={<ToggleLabel />}
        messages={{
          on: 'Global',
          off: 'From snapshot',
        }}
      />
      <DeviceAttributesFilter
        value={value}
        onChange={setValue}
        globalAttributes={globalAttributes}
      />
    </>
  );
};
